import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabaseGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 166,
	height: 95,
	viewBox: "0 0 166 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M165.833 15.0537H85V48.3601V48.7343H85.0145C85.5932 56.2085 103.46 62.2066 125.417 62.2066C147.373 62.2066 165.24 56.2085 165.819 48.7343H165.833V48.3601V15.0537Z",
			fill: "#9FB3C1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M165.833 15.0537H85V48.3601V48.7343H85.0145C85.5932 56.2085 103.46 62.2066 125.417 62.2066C147.373 62.2066 165.24 56.2085 165.819 48.7343H165.833V48.3601V15.0537Z",
			fill: "url(#paint0_linear_1152_62453)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 125.417,
			cy: 14.6797,
			rx: 40.4167,
			ry: 13.8465,
			fill: "#D9E3ED"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_1152_62453",
				style: { maskType: "alpha" },
				"mask-units": "userSpaceOnUse",
				x: 84,
				y: 10,
				width: 83,
				height: 32,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M166.251 26.2499C166.251 28.216 165.187 30.1393 163.15 31.9385C161.115 33.7372 158.145 35.3761 154.44 36.7608C147.033 39.5292 136.772 41.2499 125.418 41.2499C114.064 41.2499 103.803 39.5292 96.3957 36.7608C92.6905 35.3761 89.7211 33.7372 87.6855 31.9385C85.6493 30.1393 84.5846 28.216 84.5846 26.2499C84.5846 24.2838 85.6493 22.3605 87.6855 20.5613C89.7211 18.7626 92.6905 17.1237 96.3957 15.739C103.803 12.9706 114.064 11.2499 125.418 11.2499C136.772 11.2499 147.033 12.9706 154.44 15.739C158.145 17.1237 161.115 18.7626 163.15 20.5613C165.187 22.3605 166.251 24.2838 166.251 26.2499Z",
					stroke: "#8FA4B7",
					strokeWidth: .833333
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_1152_62453)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 85.002,
					y: 27.5,
					width: 80.8333,
					height: 16.6667,
					fill: "#869DB2"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask1_1152_62453",
				style: { maskType: "alpha" },
				"mask-units": "userSpaceOnUse",
				x: 84,
				y: 21,
				width: 83,
				height: 32,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M166.251 37.0834C166.251 39.0495 165.187 40.9728 163.15 42.772C161.115 44.5707 158.145 46.2096 154.44 47.5943C147.033 50.3627 136.772 52.0834 125.418 52.0834C114.064 52.0834 103.803 50.3627 96.3957 47.5943C92.6905 46.2096 89.7211 44.5707 87.6855 42.772C85.6493 40.9728 84.5846 39.0495 84.5846 37.0834C84.5846 35.1173 85.6493 33.194 87.6855 31.3948C89.7211 29.5961 92.6905 27.9572 96.3957 26.5725C103.803 23.8041 114.064 22.0834 125.418 22.0834C136.772 22.0834 147.033 23.8041 154.44 26.5725C158.145 27.9572 161.115 29.5961 163.15 31.3948C165.187 33.194 166.251 35.1173 166.251 37.0834Z",
					stroke: "#8FA4B7",
					strokeWidth: .833333
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask1_1152_62453)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 85.002,
					y: 38.3335,
					width: 80.8333,
					height: 16.6667,
					fill: "#869DB2"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M80.8333 14.2207H0V47.5269V47.9013H0.0144881C0.593602 55.3754 18.4606 61.3733 40.4167 61.3733C62.3727 61.3733 80.2397 55.3754 80.8188 47.9013H80.8333V47.5269V14.2207Z",
			fill: "#9FB3C1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M80.8333 14.2207H0V47.5269V47.9013H0.0144881C0.593602 55.3754 18.4606 61.3733 40.4167 61.3733C62.3727 61.3733 80.2397 55.3754 80.8188 47.9013H80.8333V47.5269V14.2207Z",
			fill: "url(#paint1_linear_1152_62453)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.4167,
			cy: 13.8465,
			rx: 40.4167,
			ry: 13.8465,
			fill: "#D9E3ED"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask2_1152_62453",
				style: { maskType: "alpha" },
				"mask-units": "userSpaceOnUse",
				x: -1,
				y: 10,
				width: 83,
				height: 31,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M81.2513 25.4167C81.2513 27.3828 80.1866 29.3061 78.1504 31.1053C76.1148 32.904 73.1454 34.5428 69.4403 35.9276C62.0331 38.6959 51.7722 40.4167 40.418 40.4167C29.0637 40.4167 18.8029 38.6959 11.3957 35.9276C7.69054 34.5428 4.72111 32.904 2.6855 31.1053C0.649304 29.3061 -0.415365 27.3828 -0.415365 25.4167C-0.415365 23.4506 0.649304 21.5272 2.6855 19.728C4.72111 17.9293 7.69054 16.2905 11.3957 14.9057C18.8029 12.1374 29.0637 10.4167 40.418 10.4167C51.7722 10.4167 62.0331 12.1374 69.4403 14.9057C73.1454 16.2905 76.1148 17.9293 78.1504 19.728C80.1866 21.5272 81.2513 23.4506 81.2513 25.4167Z",
					stroke: "#8FA4B7",
					strokeWidth: .833333
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask2_1152_62453)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: .00195312,
					y: 26.6667,
					width: 80.8333,
					height: 16.6667,
					fill: "#869DB2"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask3_1152_62453",
				style: { maskType: "alpha" },
				"mask-units": "userSpaceOnUse",
				x: -1,
				y: 20,
				width: 83,
				height: 32,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M81.2513 36.2502C81.2513 38.2162 80.1866 40.1396 78.1504 41.9388C76.1148 43.7375 73.1454 45.3763 69.4403 46.7611C62.0331 49.5294 51.7722 51.2502 40.418 51.2502C29.0637 51.2502 18.8029 49.5294 11.3957 46.7611C7.69054 45.3763 4.72111 43.7375 2.6855 41.9388C0.649304 40.1396 -0.415365 38.2162 -0.415365 36.2502C-0.415365 34.2841 0.649304 32.3607 2.6855 30.5615C4.72111 28.7628 7.69054 27.124 11.3957 25.7392C18.8029 22.9709 29.0637 21.2502 40.418 21.2502C51.7722 21.2502 62.0331 22.9709 69.4403 25.7392C73.1454 27.124 76.1148 28.7628 78.1504 30.5615C80.1866 32.3607 81.2513 34.2841 81.2513 36.2502Z",
					stroke: "#8FA4B7",
					strokeWidth: .833333
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask3_1152_62453)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: .00195312,
					y: 37.5002,
					width: 80.8333,
					height: 16.6667,
					fill: "#869DB2"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M120.833 47.5537H40V80.8601V81.2343H40.0145C40.5932 88.7085 58.4603 94.7066 80.4167 94.7066C102.373 94.7066 120.24 88.7085 120.819 81.2343H120.833V80.8601V47.5537Z",
			fill: "#9FB3C1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M120.833 47.5537H40V80.8601V81.2343H40.0145C40.5932 88.7085 58.4603 94.7066 80.4167 94.7066C102.373 94.7066 120.24 88.7085 120.819 81.2343H120.833V80.8601V47.5537Z",
			fill: "url(#paint2_linear_1152_62453)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 80.4167,
			cy: 47.1797,
			rx: 40.4167,
			ry: 13.8465,
			fill: "#D9E3ED"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask4_1152_62453",
				style: { maskType: "alpha" },
				"mask-units": "userSpaceOnUse",
				x: 39,
				y: 43,
				width: 83,
				height: 32,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M121.251 58.7499C121.251 60.716 120.187 62.6393 118.15 64.4385C116.115 66.2372 113.145 67.8761 109.44 69.2608C102.033 72.0292 91.7722 73.7499 80.418 73.7499C69.0637 73.7499 58.8029 72.0292 51.3957 69.2608C47.6905 67.8761 44.7211 66.2372 42.6855 64.4385C40.6493 62.6393 39.5846 60.716 39.5846 58.7499C39.5846 56.7838 40.6493 54.8605 42.6855 53.0613C44.7211 51.2626 47.6905 49.6237 51.3957 48.239C58.8029 45.4706 69.0637 43.7499 80.418 43.7499C91.7722 43.7499 102.033 45.4706 109.44 48.239C113.145 49.6237 116.115 51.2626 118.15 53.0613C120.187 54.8605 121.251 56.7838 121.251 58.7499Z",
					stroke: "#8FA4B7",
					strokeWidth: .833333
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask4_1152_62453)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 40.002,
					y: 60,
					width: 80.8333,
					height: 16.6667,
					fill: "#869DB2"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask5_1152_62453",
				style: { maskType: "alpha" },
				"mask-units": "userSpaceOnUse",
				x: 39,
				y: 54,
				width: 83,
				height: 31,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M121.251 69.5834C121.251 71.5495 120.187 73.4728 118.15 75.272C116.115 77.0707 113.145 78.7096 109.44 80.0943C102.033 82.8627 91.7722 84.5834 80.418 84.5834C69.0637 84.5834 58.8029 82.8627 51.3957 80.0943C47.6905 78.7096 44.7211 77.0707 42.6855 75.272C40.6493 73.4728 39.5846 71.5495 39.5846 69.5834C39.5846 67.6173 40.6493 65.694 42.6855 63.8948C44.7211 62.0961 47.6905 60.4572 51.3957 59.0725C58.8029 56.3041 69.0637 54.5834 80.418 54.5834C91.7722 54.5834 102.033 56.3041 109.44 59.0725C113.145 60.4572 116.115 62.0961 118.15 63.8948C120.187 65.694 121.251 67.6173 121.251 69.5834Z",
					stroke: "#8FA4B7",
					strokeWidth: .833333
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask5_1152_62453)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 40.002,
					y: 70.8335,
					width: 80.8333,
					height: 16.6667,
					fill: "#869DB2"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1152_62453",
				x1: 85,
				y1: 34.9997,
				x2: 165.833,
				y2: 38.333,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B4C7D9" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B3BCD2",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1152_62453",
				x1: 9.76665e-8,
				y1: 34.1667,
				x2: 80.8333,
				y2: 37.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B4C7D9" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B3BCD2",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1152_62453",
				x1: 40,
				y1: 67.4997,
				x2: 120.833,
				y2: 70.833,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B4C7D9" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B3BCD2",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgDatabaseGroup;
